import { mapPlaceTypesToKorean } from "../utils/placeCategory";
import axios from "axios";

export const usePlaceRegister = () => {
    const registerFromPlace = async (placeId, cityName, onSuccess, savedRestaurants) => {  // ✅ savedRestaurants 매개변수 추가
        try {
            // ✅ DB ID(숫자)면 중복 체크만 하고 스킵
            if (typeof placeId === 'number') {
                alert('이미 등록된 맛집입니다!');
                return;
            }
            // ✅ Google placeId(문자열)만 Places API 호출
            if (typeof placeId !== 'string' || !placeId.startsWith('ChIJ')) {
                alert('❌ 유효하지 않은 placeId입니다.');
                return;
            }
            const { Place } = await window.google.maps.importLibrary("places");
            const place = new Place({ id: placeId, requestedLanguage: "ko" });
            await place.fetchFields({
                fields: ["displayName", "formattedAddress", "types", "location"],
            });

            // ✅ 1. 중복 체크 (이름 + 좌표 50m 이내)
            const newLat = place.location.lat();
            const newLng = place.location.lng();

            const existing = savedRestaurants?.find(r =>
                r.name === place.displayName &&
                Math.abs(r.lat - newLat) < 0.0005 &&  // 약 50m 오차 허용
                Math.abs(r.lng - newLng) < 0.0005
            );

            if (existing) {
                alert(
                    `⚠️ 이미 등록된 맛집입니다!\n\n` +
                    `${existing.koreanName || existing.name}\n` +
                    `📍 ${existing.address}\n` +
                    `🏷️ ${existing.category || '카테고리 없음'}`
                );
                return;
            }

            const category = mapPlaceTypesToKorean(place.types ?? [], place.displayName);
            const token = localStorage.getItem("token");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};

            // ✅ 2. 한글 이름 입력
            const koreanName = window.prompt(
                `✅ "${place.displayName}" 등록 준비 완료!\n카테고리: ${category}\n\n① 한글 이름을 입력해주세요 (선택사항)\n예)스타벅스 강남점`,
                ""
            );
            if (koreanName === null) return;

            // ✅ 3. 메모 입력
            const memo = window.prompt(
                `② 메모를 입력해주세요 (선택사항)\n예)커피맛집!,커피가 유명해요`,
                ""
            );
            if (memo === null) return;

            const payload = {
                name: place.displayName,
                koreanName: koreanName.trim() || null,
                address: place.formattedAddress,
                category,
                memo: memo.trim() || null,
                lat: newLat,
                lng: newLng,
                city: cityName,
            };

            await axios.post("/api/restaurants", payload, { headers });
            alert(`✅ "${koreanName.trim() || place.displayName}" 등록 완료!`);
            onSuccess?.();

        } catch (e) {
            if (e.response) {
                console.error("❌ 서버 응답 오류:", e.response.status, e.response.data);
                alert(`❌ 등록 실패: ${e.response.status}`);
            } else {
                console.error("등록 오류:", e);
                alert("장소 정보를 가져오지 못했습니다.");
            }
        }
    };

    return { registerFromPlace };
};
